import $ from "jquery";

export default function () {
    const $inputCountry = $('#inputCountry');
    if ($inputCountry.length) {
        $inputCountry.select2({
            theme: "bootstrap-5",
            ajax: {
                url: inputCountriesUrl,
                dataType: 'json'
                // Additional AJAX parameters go here; see the end of this chapter for the full code of this example
            }
        });

        if ($('#inputCountry').val() == 'Italy') {
            $('#inputProvincia').parent().removeClass('d-none');
        }

        $('#inputCountry').change(function () {
            if ($(this).val() == 'Italy') {
                $('#inputProvincia').parent().removeClass('d-none');
            } else {
                $('#inputProvincia').parent().addClass('d-none');
            }
        });
    }

    const $inputProvince = $('#inputProvincia');
    if ($inputProvince.length) {
        $inputProvince.select2({
            theme: "bootstrap-5",
            ajax: {
                url: inputProvincesUrl,
                dataType: 'json'
                // Additional AJAX parameters go here; see the end of this chapter for the full code of this example
            }
        });
    }
}
